import { render, staticRenderFns } from "./SupplyPoint.vue?vue&type=template&id=56275522"
import script from "./SupplyPoint.vue?vue&type=script&lang=js"
export * from "./SupplyPoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports